import { render, staticRenderFns } from "./CreateCenterPage.vue?vue&type=template&id=12794568&scoped=true"
import script from "./CreateCenterPage.vue?vue&type=script&lang=js"
export * from "./CreateCenterPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12794568",
  null
  
)

export default component.exports